// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6e2e5643","314":"809a59a6","574":"3629242b","787":"0338cd24","972":"8e1cdb7e"}[chunkId] + ".chunk.js";
};